<template>
    <span>
        <b-btn :disabled="!$store.getters.getCanSign" class="atmo-button atmo-accented" @click="showModal = true">Отказаться от отправки контракта</b-btn>
        <b-modal v-model="showModal" centered no-close-on-backdrop no-close-on-esc scrollable size="md" title="Отказ от отправки контракта поставщику" @close="cancelSendModal" @hide="cancelSendModal">
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <form-row-edit-textarea label="Причина отказа" v-model="comment" :v="$v.comment" :rows="5" label-on-top />
            <h6 class="text-danger fw-600">В случае отказа от отправки контракта поставщику в соответствии с Регламентом ИС АТМО внесение закупки вне ИС на основании этой закупки будет недоступно.</h6>
            <h6 class="text-danger fw-600">Обращаем Ваше внимание, что данное действие необратимо.</h6>
            <div slot="modal-footer" class="w-100 px-3">
                <b-button :disabled="isDataSending" class="mr-2 atmo-button-inverse atmo-dimmed" @click="cancelSendModal">Отмена</b-button>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="$v.$invalid" class="atmo-button atmo-accented" @click="sendDecline">Отказаться</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';

export default {
    name: 'fl44-decline-contract-send-button',
    props: {
        purchaseItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showModal: false,
            isDataSending: false,
            comment: ''
        };
    },
    validations: {
        comment: {
            required,
            minLength: minLength(10)
        }
    },
    methods: {
        cancelSendModal() {
            this.showModal = false;
            this.comment = '';
        },
        async sendDecline() {
            this.isDataSending = true;
            await this.$api.personal.fl44
                .declineSendContract(this.purchaseItem.id, { comment: this.comment })
                .then((response) => {
                    if (response) {
                        this.cancelSendModal();
                        this.$emit('refresh');
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        }
    }
};
</script>
